import React from 'react'
import styles from '~/styles/molecules/navigation/navigation.module.scss'

import NavigationMainItem, { NavigationMainItemVar } from '~/components/molecules/navigation/main/NavigationMainItem'

interface Props {
  items: NavigationMainItemVar[]
}

const NavigationMainList = ({items}: Props) => {
  return (
    <ul className={styles.main__list}>
      {items.map((item) =>
        <NavigationMainItem key={item.id} item={item}/>
      )}
    </ul>
  )
}

export default NavigationMainList